import {ListerrorsComponent} from './errors/listerrors.component';
import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {ShowAuthedDirective} from './directives/show-authed.directive';
import {ShowCompanyAuthedDirective} from './directives/show-company-authed.directive';
import {SidebarComponent} from './sidebar';
import {TopNavComponent} from './topnav';
import { BrowserModule } from '@angular/platform-browser';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {ToastyModule} from 'ng2-toasty';
import { SlugifyPipe } from './pipes/slugify.pipe';
import { SafePipe } from './pipes/safe.pipe';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    NgbDropdownModule,
    ToastyModule.forRoot(),
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule
  ],
  declarations: [
    ListerrorsComponent,
    ShowAuthedDirective,
    ShowCompanyAuthedDirective,
    TopNavComponent,
    SidebarComponent,
    SlugifyPipe,
    SafePipe
  ],
  exports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ToastyModule,
    ReactiveFormsModule,
    HttpClientModule,
    ListerrorsComponent,
    ShowAuthedDirective,
    ShowCompanyAuthedDirective,
    RouterModule,
    TopNavComponent,
    SidebarComponent,
    SlugifyPipe,
    SafePipe
  ]
})
export class SharedModule {}
